module.exports = __webpack_public_path__ + "img/2.c036c422.png";